// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingShippingPanel_root__V3akv","form":"EditListingShippingPanel_form__3Bc8R","title":"EditListingShippingPanel_title__3eeJ-"};